import ViewRenderer from "./view-renderer";

export default function Body() {
  return (
    <div className="w-full flex-none md:block md:px-0">
      <ViewRenderer />
    </div>
  );
}
